import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import _ from "lodash";

export const selectVoucherdefsFromShoppingCartMap = createSelector(
  [(state: RootState) => state.vouchersV2.vouchers],
  (vouchers) => {
    return _.chain(vouchers)
      .keyBy("voucherdef.id")
      .mapValues((voucherComplex) => voucherComplex.voucherdef)
      .value();
  }
);
